import { Field } from "formik";
import { RenderableInputProps } from ".";
import { useValidateRenderableInput } from "./renderableInputUtils";
import "./RenderableInput.css";

export type RenderableNumberInputProps = RenderableInputProps<"number", number>;

export default function RenderableNumberInput({
  id,
  name,
  description,
  validation,
}: RenderableNumberInputProps) {
  const validate = useValidateRenderableInput(id, validation);

  return (
    <Field type="number" name={id} validate={validate}>
      {({ field, meta }) => (
        <div
          id="renderable-input"
          className={meta.touched && meta.error ? "error" : undefined}
        >
          <div className="above">
            <label>{name}</label>
          </div>
          <input type="number" {...field} />
          {description && <div className="description">{description}</div>}
          {meta.touched && meta.error && meta.value !== undefined && (
            <div className="error">{meta.error}</div>
          )}
        </div>
      )}
    </Field>
  );
}
